import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'

import { clusterRepository } from '../../infrastructure/clusterRepo'
import type { UpdateClusterRequest } from '../../domain/types'

type UpdateClusterParams = {
  id: string
  body: UpdateClusterRequest
}

export function useUpdateCluster() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, body }: UpdateClusterParams) => {
      const result = await clusterRepository.update(id, body)

      if (!result.response.ok) {
        // Every backend error body is {"error": "<string>"}; the spec does
        // not model it, so it is read untyped.
        const errorBody = result.error as unknown as
          | { error?: string }
          | undefined
        throw new Error(
          errorBody?.error ||
            `Cluster could not be updated (HTTP ${result.response.status})`,
        )
      }

      return { id, body }
    },

    onError: (error: Error) => {
      toast.error(error.message)
    },

    onSuccess: () => {
      toast.success('Cluster was updated')
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['clusters'] })
    },
  })
}
